import { Injectable } from "@angular/core";

@Injectable()
export class CleanFilePathService {
  private GEM_ROOT = "/GEM_ROOT";
  private GEM_ROOT2 = "[GEM_ROOT]";
  private PROJECT_ROOT = "/PROJECT_ROOT/";
  private PROJECT_ROOT2 = "[PROJECT_ROOT]/";
  private WEBPACK_ROOT = "webpack:///";

  public clean(path: string, rootDir?: string) {
    if (path == null) {
      return "";
    }

    if (rootDir) {
      path = path.replace(new RegExp(`^${rootDir}/?`), "");
    }

    if (path.startsWith(this.PROJECT_ROOT)) {
      return path.slice(this.PROJECT_ROOT.length);
    }

    if (path.startsWith(this.PROJECT_ROOT2)) {
      return path.slice(this.PROJECT_ROOT2.length);
    }

    if (path.startsWith(this.GEM_ROOT)) {
      return path.slice(this.GEM_ROOT.length);
    }

    if (path.startsWith(this.GEM_ROOT2)) {
      return path.slice(this.GEM_ROOT2.length);
    }

    if (path.startsWith(this.WEBPACK_ROOT)) {
      return path.slice(this.WEBPACK_ROOT.length);
    }

    return path;
  }
}
